import CompetitionService from '../services/CompetitionDataService';
import MyComputed from '../myComputed';

// Data:
// activeCompetitions - all competitions active for the user
// selectedCompetition - the competition that is currently selected in dropdown
// currentCompetition - as a getter

const localStorage_competition = localStorage.getItem('store_competition')
  ? JSON.parse(localStorage.getItem('store_competition')).competition
  : undefined;

// Could we log the before and after initial state?
const initialState = localStorage_competition
  ? {
    activeCompetitions: localStorage_competition.activeCompetitions,
    selectedCompetitionId: localStorage_competition.selectedCompetitionId,
  }
  : {
    activeCompetitions: [],
    selectedCompetitionId: null,
  };

export const competition = {
  namespaced: true,
  state: initialState,
  actions: {
    async updateActiveCompetitions({ commit }) {
      // console.log("updateActiveCompetitions - action");
      // console.log("participantCompetitions");
      // console.log(MyComputed.participantCompetitions);
      if (MyComputed.participantCompetitions && MyComputed.participantCompetitions.length > 0) {
        // console.log("updateActiveCompetitions - action - has MyComputed.participantCompetitions");
        commit('SET_ACTIVE_COMPETITIONS', MyComputed.participantCompetitions);
        return MyComputed.participantCompetitions;
      } else {
        // console.log("updateActiveCompetitions - action - no MyComputed.participantCompetitions");
        try {
          // console.log("updateActiveCompetitions - action - Calling CompetitionService.findCompetitionsActive...");
          const response = await CompetitionService.findCompetitionsActive();
          // console.log("updateActiveCompetitions - action - success");
          // console.log(response.data.competitions);
          if (response.data.competitions && response.data.competitions.length > 0) {
            commit('SET_ACTIVE_COMPETITIONS', response.data.competitions);
          }
          return response.data.competitions;
        } catch (error) {
          console.log("updateActiveCompetitions - action - error");
          throw error;
        }
      }
    },
    setActiveCompetitions({ commit }, competitions) {
      // console.log("setActiveCompetitions - action");
      // console.log(competitions);
      if (competitions && competitions.length > 0) {
        commit('SET_ACTIVE_COMPETITIONS', competitions);
      }
    },
    setSelectedCompetitionId({ commit }, competition_id) {
      // console.log("setSelectedCompetitionId - action");
      // console.log(competition_id);
      commit('SET_SELECTED_COMPETITION_ID', competition_id);
    },
  },
  mutations: {
    SET_ACTIVE_COMPETITIONS(state, competitions) {
      state.activeCompetitions = competitions;
    },
    SET_SELECTED_COMPETITION_ID(state, competition_id) {
      state.selectedCompetitionId = competition_id;
    },
  }
};
